import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { IAppConfig } from '../Config/app-config.model';
import { Regulation } from 'src/app/shared/model/regulation.model';
import { ThresholdCategory } from 'src/app/shared/model/threshold-category.model';

@Injectable({
  providedIn: 'root'
})
export class RegulationService extends BaseService {
  
  constructor(public _injector: Injector, @Inject('appconfig') private configParam: IAppConfig) {
    super(_injector);
  }
  
  GetRegulationsByThresholdCategoryId(thresholdCategoryId: string): Observable<Regulation[]> {
    return this.Get<Regulation[]>(`${this.configParam.ApiConfig.API_ENDPOINT}Regulation/GetByThresholdCategoryId/${thresholdCategoryId}`);
  }

  GetRegulationsByThresholdCategoryIds(selectedThresholds:  ThresholdCategory[]) {

    let QueryStr = '';
    selectedThresholds.forEach(selectedThreshold => {
      QueryStr = QueryStr == ''? '?thresholdIds=' + selectedThreshold.thresholdId: QueryStr + '&thresholdIds=' +selectedThreshold.thresholdId     

    })

    return this.Get<Regulation[]>(`${this.configParam.ApiConfig.API_ENDPOINT}Regulation/GetByThresholdCategoryIds${QueryStr}`);
  }
}
